import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Testimonials = () => {
  const settings = {
    dots: true,
    arrows: true,
    infinite: true,
    speed: 1200,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 7000,
    responsive: [
      { breakpoint: 1200, settings: { slidesToShow: 2 } },
      { breakpoint: 768, settings: { slidesToShow: 1 } },
    ],
  };

  const testimonials = [
  {
    image: "/images/resource/thumb-image-1.png",
    name: "Mr. Rajesh Kumar",
    designation: "Business Owner",
    text: "“Seamless Booking and Pickup! I booked a cab with Sai Trupti Cabs, and the process was incredibly smooth. The online booking system is user-friendly, and the pickup was quick and efficient.”",
  },
  {
    image: "/images/resource/thumb-image-2.png",
    name: "Miss. Priya Mehta",
    designation: "Travel Blogger",
    text: "“Fantastic service! The cab was clean, well-maintained, and the driver was polite and punctual. Highly recommended for hassle-free travel with Sai Trupti Cabs.”",
  },
  {
    image: "/images/resource/thumb-image-1.png",
    name: "Mr. Anil Sharma",
    designation: "Entrepreneur",
    text: "“Highly reliable cab service. I’ve used Sai Trupti Cabs multiple times, and they never disappoint. Easy booking, great support, and smooth rides.”",
  },
  {
    image: "/images/resource/thumb-image-2.png",
    name: "Miss. Sneha Gupta",
    designation: "Marketing Executive",
    text: "“Excellent experience! Booking was simple, pricing was transparent, and the entire trip was comfortable. I’ll definitely book again with Sai Trupti Cabs.”",
  },
];


  return (
    <section className="testimonials-section pt120 pb_0 grey-bg">
      <div className="container">
        <div className="section-title centred mb_60">
          <span className="sub-title">Testimonials</span>
          <h2 className="title">What our Clients Says</h2>
        </div>

        <Slider {...settings}>
          {testimonials.map((item, index) => (
            <div className="testimonial-block-one style-two" key={index}>
              <div className="inner-box">
                <div className="author-box">
                  {/* <figure className="author-image">
                    <img src={item.image} alt={item.name} />
                  </figure> */}
                  <div className="author-info">
                    <h5>{item.name}</h5>
                    <span className="designation">{item.designation}</span>
                  </div>
                </div>

                <ul className="author-rating">
                  {[...Array(5)].map((_, i) => (
                    <li key={i}>
                      <i className="icon-21"></i>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="author-comments">
                <p>{item.text}</p>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
};

export default Testimonials;
